import React, { useContext } from 'react';
import { Button } from '../../ui/button';
import { X } from 'react-bootstrap-icons';
import { LocalizeContext } from 'react-locale-language';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { cn } from '../../../lib/utils';

const DialogModal = ({
  children,
  visible = false,
  title = '',
  showCloseButton = true,
  onClose,
  disableCloseButton = false,
  className = 'lg:max-w-[95%] lg:max-h-[95%]',
  customHeaderButtons = null
}) => {
  const { translate } = useContext(LocalizeContext);

  const Header = () => {
    if (!title && !showCloseButton && !customHeaderButtons) return null;

    return (
      <DialogHeader className="sticky top-0 bg-white z-10 flex-shrink-0 px-6 py-3 shadow-md">
        <div className="flex items-center justify-between w-full">
          {title && <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>}
          {customHeaderButtons}
          {showCloseButton && (
            <Button size="sm" onClick={onClose} variant="destructive" disabled={disableCloseButton}>
              {translate('close')} <X size={16} className="ml-1" />
            </Button>
          )}
        </div>
      </DialogHeader>
    );
  };

  return (
    <Dialog open={visible} onOpenChange={open => !open && onClose && onClose()}>
      <DialogContent
        className={cn(
          '[&>button]:hidden p-0 flex flex-col gap-0 overflow-hidden lg:rounded-lg',
          className,
          'max-w-full max-h-full rounded-none'
        )}
      >
        <Header />
        <div className="overflow-y-auto flex-1 px-6 py-4">{children}</div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogModal;
